module.exports = __webpack_public_path__ + "static/img/img08.5a12ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img08.png
// module id = gstw
// module chunks = 1